import { Button } from '@/components/ui/button';
import { useImportSubjectPackage, useSubjectPackages } from '../../planner/api';
import { iconFor } from '../../planner/subjectStyle';

/** Ready-made subject lists (e.g. "Drieluik - Groep 8") so the teacher does not have to type every subject in. */
export default function PackageImport() {
  const packages = useSubjectPackages();
  const importPackage = useImportSubjectPackage();
  if (!packages.data || packages.data.length === 0) return null;

  return (
    <section aria-label="Vakkenpakket importeren" className="flex flex-col gap-3 border p-3">
      <h2 className="text-xl">Vakkenpakket importeren</h2>
      {packages.data.map((pack) => (
        <div key={pack.key} className="flex flex-col gap-2">
          <div className="flex flex-wrap items-center gap-3">
            <strong>{pack.name}</strong>
            <span className="flex-1" />
            <Button type="button" className="min-h-11" disabled={importPackage.isPending} onClick={() => importPackage.mutate(pack.key)}>
              {pack.name} importeren
            </Button>
          </div>
          <p className="text-sm opacity-80">{pack.description}</p>
          <p className="text-sm">
            {pack.subjects.map((subject) => (
              <span key={subject.name} className="mr-3 inline-block whitespace-nowrap">
                <span aria-hidden="true">{iconFor(subject.icon)}</span> {subject.name}
                {subject.fields.length > 0 && <span className="opacity-70"> ({subject.fields.join(', ')})</span>}
              </span>
            ))}
          </p>
        </div>
      ))}
      <p className="text-sm opacity-80">Vakken die je al hebt (zelfde naam) houden hun naam, kleur en icoon; ze krijgen alleen velden als ze er nog geen hebben. Alles kun je daarna zelf aanpassen.</p>
      {importPackage.isSuccess && (
        <p role="status" className="text-sm">
          {importPackage.data.added} {importPackage.data.added === 1 ? 'vak' : 'vakken'} toegevoegd
          {importPackage.data.updated > 0 && `, ${importPackage.data.updated} bestaand${importPackage.data.updated === 1 ? ' vak' : 'e vakken'} ${importPackage.data.updated === 1 ? 'kreeg' : 'kregen'} velden`}
          {importPackage.data.skipped > 0 && `, ${importPackage.data.skipped} ${importPackage.data.skipped === 1 ? 'bleef' : 'bleven'} ongewijzigd`}.
        </p>
      )}
      {importPackage.isError && (
        <p role="alert" className="text-sm">
          Importeren is niet gelukt. Probeer het opnieuw.
        </p>
      )}
    </section>
  );
}
